import React, { ReactNode, useEffect, useState } from 'react';
import { Route, Switch, useHistory, useParams } from 'react-router-dom';
import EntityDataTable, { Column } from '../Models/EntityDataTable';
import Editor from '../Models/Editor';
import useFetch from '../../Services/useFetch';
import { endpoints } from '../../utils/Constants';
import { Button, Container, Row, Col } from 'reactstrap';
import LoadingAnimation from '../Form/LoadingAnimation';
import entities from '../../utils/entities';

interface entity {
    id: string, name: string, plural: string, hideViewButton?: unknown, newItem?: Function, addSingle?: string,
    editor?: (props?: Object) => JSX.Element, itemParam: string, getByStatus(x: object): string, title: string,
    columns: Column[];
}

interface props {
    hideActions?: boolean;
    route: string;
    routes?: JSX.Element;
    entity: object & entity;
    parentEntity?: entity;
    heightOffset?: number;
    headerHeight?: number;
    parentHeight?: number;
    item?: object & { id: string };
    id?: string;
    actions?: Record<string, unknown>[];
    dateFrom?: string;
    dateTo?: string;
    fromChange?: string;
    toChange?: string;
}

const ManageEntityList = ({ hideActions, route, routes, entity, headerHeight, parentHeight, item, actions, dateFrom, dateTo, fromChange, toChange }: props) => {

    let { push } = useHistory();
    let params = useParams();
    const [newItem, setNewItem] = useState(undefined as undefined | object)

    const setLocation = (activeKey) => {

        push(route + '/' + activeKey);
    }
    const [allowedActions, loadingActions, loadingError, refreshActions] = useFetch(!hideActions && entity ? endpoints.getActionsForEntityList + entity.name : "");
    const [listActions, setListActions] = useState(undefined as unknown);
    const listItemActions: Record<string, unknown>[] = entity.hideViewButton ? [] : actions ? actions : [{ name: 'View', action: (row) => setLocation(row.id) },];
    const defaultHeight = parentHeight ? parentHeight - (headerHeight ? headerHeight : 0) : null;

    const onAddEntity = () => {
        setNewItem(entity.newItem ? entity.newItem : () => true);
    }
    useEffect(() => {
        const newActions = () => {

            return <React.Fragment >
                {loadingError ? <h6>Error Loading Actions<Button onclick={refreshActions} /> </h6> : null}

                {!hideActions && !loadingActions ?
                    allowedActions instanceof Array && allowedActions.map((x, i) => {

                        const handleClick = () => {

                            if (x.actionType === 'ListRoute') {
                                push(route + '/' + x.appRoute);
                            }
                            else {
                                setNewItem(entity.newItem ? entity.newItem({ ...item, status: x.nextState }) : true);
                            }
                        }
                        return entity.addSingle ? <Button style={{ margin: '15px' }} key={i} onClick={() => handleClick()}>{x.actionName}</Button> : null
                    }) : hideActions ? null : <LoadingAnimation height={50} />
                }</React.Fragment >
        }
        setListActions(newActions);

    }, [allowedActions, loadingActions, loadingError, hideActions, entity, push, item, route, refreshActions]);

    const editorClosed = () => {
        setNewItem(undefined);
        push(route);

    }
    return <div>
        {entity.editor ? <Editor route={route} entity={entity} item={item!} itemId={params[entity.itemParam]} newItem={newItem} editorClosed={editorClosed}>
            {entity.editor({ item })}
        </Editor> : null}

        <EntityDataTable route={route} item={item} headerHeight={headerHeight} addEntity={onAddEntity} parentHeight={defaultHeight} entity={entity} title={<Container><Row><Col><h1> {'Manage ' + entity.plural}</h1></Col><Col>{listActions as ReactNode}</Col></Row></Container>} actions={listItemActions} dateFrom={dateFrom} dateTo={dateTo} fromChange={fromChange} toChange={toChange} />
        <Switch>
            {allowedActions instanceof Array && allowedActions.map(x => (
                x.actionType === 'ListRoute' ? <Route key={x.id} path={route + '/' + x.appRoute} render={() =>
                    <Editor route={route + '/' + x.appRoute} entity={{ ...entities[x.appRoute], parentEntity: entity }} itemId={item!.id} newItem={entities[x.appRoute]} editorClosed={() => push(route)}>
                        <ManageEntityList route={route + '/' + x.appRoute} entity={entities[x.appRoute]} parentHeight={400} parentEntity={entity} />
                    </Editor>} /> : null
            ))}
            {routes}

        </Switch>
    </div>
}

export default ManageEntityList;

